import { isArray, isString } from 'lodash'
import BrowserUtils from './BrowserUtils'
import DOMUtils from './DOMUtils'
import TextUtils from './TextUtils'

declare let window: any
declare let com: any

export function notifyErrors(vs: any, error: any, time = 2000) {
  // Suporta tanto error.data (string JSON) quanto error.response.data (objeto já parseado)
  let data: any = null
  if (error.response && error.response.data) {
    data = error.response.data
  } else if (error.data) {
    data = typeof error.data === 'string' ? JSON.parse(error.data) : error.data
  }

  if (data) {
    let errors: any = data.errors || data.messages

    if (isString(errors))  {
      try {
        errors = JSON.parse(errors)
        if (isArray(errors)) {
          errors = Object.assign({}, errors)
        }
      } catch (error) {
        console.error(`cannot convert string errors from assumed json ${errors}`)
      }
    }

    if (errors) {
      // Se errors é um array (formato do ApiResponseResource com messages)
      if (isArray(errors)) {
        errors.forEach((item: any) => {
          const text = item.msg || item.message || item
          vs.notify({
            time: time,
            title: 'Erro',
            text: text,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'op-center'
          })
        })
      } else {
        // Se errors é um objeto (formato de validação)
        Object.keys(errors).forEach(key => {
          if (key in errors) {
            let text = errors[key]
            if (isArray(text)) {
              text = text[0]
            }

            vs.notify({
              time: time,
              title: 'Erro',
              text: text,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'op-center'
            })
          }
        })
      }
    }
  }
}

export function loadingOnOff  (vs: any, view: boolean){
  if(view){
    vs.loading()
  }else{
    vs.loading.close()
  }
}

export default {
  install(Vue: any) {

    /* Each util function in $utils is
    * categorized through its parent object.
    * The idea is to convert all the functions in this file,
    * to inside this structured object. TODO
    */
    Vue.prototype.$utils = {
      browser : {
        ...BrowserUtils
      },
      DOM: {
        ...DOMUtils
      },
      format : {
        featherIcon: {
          fromNotify: (icon: string) => {
            const iconStr = icon.split('-').map((token: string, index: number, tokens: any) => {
              if (index > 0) {
                return `${token.slice(0, 1).toUpperCase()}${token.slice(1)}`
              }
            })
            if (iconStr.length > 0) {
              iconStr.push('Icon')
            }
            return iconStr.toString().replaceAll(',', '')
          }
        },
        date: (dateString: any, withTime = true) => {
          if (Vue.prototype.isEmpty(dateString)) return '-'
          const yearFormat = 'DD/MM/YYYY'
          const timeFormat = 'kk:mm'
          const format = `${yearFormat}${withTime ? ` - ${timeFormat}` : ''}`
          return Vue.prototype.$moment(dateString).format(format)
        },
        dateWithFormat: (dateString: any, formatString: any) => {
          return Vue.prototype.$moment(dateString).format(formatString)
        },
      },
      text: {
        ...TextUtils
      },
      validation: {
        number: (str: string) => {
          return /^[0-9]+$/.test(str)
        },
        email: (email: string) => {
          return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email)
        }
      },
    }

    Vue.prototype.devLog = (domain : string, ...thing: any) => {
      if (process.env.NODE_ENV === 'development') {
        console.debug(`${(new Date()).toLocaleString()}|${domain.toUpperCase()}|-> `, ...thing)
      }
    }

    Vue.prototype.showErrors = (form: any, error: any, vm: any = null) => {
      if (vm) {
        vm.notifyErrors(vm.$vs, error, 3000)
      }
      if (error.data) {
        const data = JSON.parse(error.data)
        const errors = data.errors
        if (errors && form) {
          Object.keys(errors).forEach(key => {
            form.setErrors({
              [key]: errors[key]
            })
          })
        }
      }
    }

    Vue.prototype.notifyErrors = notifyErrors

    Vue.prototype.clearErrors = (form: any) => {
      if (form) {
        form.reset()
      }
    }

    Vue.prototype.notifyError = (
      vs: any,
      message: String,
      time = 2000,
      position = 'top-center'
    ) => {
      vs.notify({
        time,
        title: 'Erro',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        position: position
      })
    }

    Vue.prototype.notifySuccess = (
      vs: any,
      message: String = '',
      time = 2000,
      position = 'top-center'
    ) => {
      const successMessage =
        message !== '' ? message : 'Operação realizada com sucesso.'
      vs.notify({
        time,
        title: 'Successo!',
        text: successMessage,
        color: 'success',
        iconPack: 'feather',
        position: position,
        icon: 'icon-check-circle'
      })
    }

    Vue.prototype.notifyWarning = (
      vs: any,
      message: String = '',
      time = 2000,
      position = 'bottom-right',
      title = 'Atenção!',
      callback: any
    ) => {
      const alertMessage = message !== '' ? message : 'Alerta.'
      vs.notify({
        time,
        title: title,
        text: alertMessage,
        color: 'warning',
        iconPack: 'feather',
        position: position,
        icon: 'icon-alert-circle',
        click: callback
      })
    }

    Vue.prototype.notifyNotification = (
      vs: any,
      message: String = '',
      time = 2000,
      callback: any,
      position = 'top-center',
      title = 'Notificação!',
      icon = 'icon-bell',
    ) => {
      const alertMessage = message !== '' ? message : 'Alerta.'
      vs.notify({
        time,
        title: title,
        text: alertMessage,
        color: 'success',
        iconPack: 'feather',
        position: position,
        icon: icon,
        click: callback
      })
    }

    Vue.prototype.clearDashDots = (naturalEntituNumber: string) => {
      return naturalEntituNumber.replace(/\./g, '').replace('-', '')
    }

    Vue.prototype.isEmpty = (object: string | null | undefined) => {
      object = isString(object) ? object.trim() : object
      return (
        object === null || // The object is null ?
        object === '' || // The object is an empty string ?
        object === undefined || // The object is undefined ?
        (
          isArray(object) && // Or is the object an array and...
            object.length === 0 // Its length is zero, contains no elements.
        )
      )
    }

    // converts HTML to text using Javascript
    Vue.prototype.html2text = (html: string) => {
      const tag = document.createElement('div')
      tag.innerHTML = html
      return tag.innerText
    }

    Vue.prototype.truncate = (str: string, n: number) => {
      return str ? (str.length > n ? `${str.substr(0, n - 1)  }...` : str) : ''
    }

    Vue.prototype.readableHumanTime = function(then: string | number | Date, brief = false) {
      const thenDate = (new Date(then))
      const nowInSeconds = Math.floor((new Date()).getTime() / 1000)
      const thenInSeconds = Math.floor(thenDate.getTime() / 1000)
      const seconds = nowInSeconds - thenInSeconds

      if (brief) {

        //Behold the easter egg, if 20 years has passed since then...
        if (seconds > (24 * 365 * 3600 * 20)) {
          const old = String.fromCodePoint(129491)
          return `a uma geração atrás... ${old}`
        }

        if (seconds > (24 * 365 * 3600)) {
          const years = seconds / (3600 * 24 * 365)
          return `a ${years.toFixed(0)} ano${years >= 2 ? 's' : ''} atrás`
        }
        if (seconds > (24 * 30 * 3600)) {
          const months = seconds / (3600 * 24 * 30)
          return `a ${months.toFixed(0)} meses${months >= 2 ? 's' : ''} atrás`
        }
        if (seconds > 48 * 3600) {
          const days = seconds / (3600 * 24)
          return `a ${days.toFixed(0)} dia${days >= 2 ? 's' : ''} atrás`
        }
        if (seconds > 24 * 3600) {
          return 'ontem'
        }
        if (seconds > 2 * 3600) {
          return `a ${(seconds / 3600).toFixed(0)}h atrás`
        }
      }

      if (seconds > 2 * 3600) {
        return thenDate.toLocaleString('pt-BR')
      }

      if (seconds > 3600) {
        return 'a 1h atrás'
      }

      if (seconds > 1 / 2 * 3600) {
        return 'a meia hora atrás'
      }

      if (seconds > 600) {
        return 'a alguns minutos atrás'
      }

      if (seconds > 300) {
        return 'a poucos minutos atrás'
      }

      if (seconds > 10) {
        return 'a instantes atrás'
      }

      if (seconds < 10) {
        return 'agora'
      }
    }

    Vue.prototype.isSmallScreen = () => {
      return window.innerWidth < 400
    }

    Vue.prototype.destroyChilds = (instance: { $children: any[] }) => {
      if (instance && instance.$children && instance.$children.length > 0) {
        instance.$children.forEach((child: { $destroy: () => void }) => {
          child.$destroy()
        })
      }
    }

    Vue.prototype.capitalize = (string: string) => {
      return `${string.charAt(0).toUpperCase()}${string.slice(1)}`
    }

    /**
     * Check if event parent of ckeditor is a table element.
     * This code is used to hack table cell blur event handled when ckeditor table is selected.
     */
    Vue.prototype.isTableParent = (e: any) => {
      // Check if selected element is a parent table
      let parent = e.source.selection.anchor.parent
      if (e && parent) {
        while (parent !== null) {
          if (parent.name === 'table') {
            return true
          }
          parent = parent.parent
        }
      }
      return false
    }

    Vue.prototype.cnpjFormat = (v: string) => {
      v=v||''
      v=v.replace(/\D/g,"")                           // Remove tudo o que não é dígito
      v=v.replace(/^(\d{2})(\d)/,"$1.$2")             // Coloca ponto entre o segundo e o terceiro dígitos
      v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3") // Coloca ponto entre o quinto e o sexto dígitos
      v=v.replace(/\.(\d{3})(\d)/,".$1/$2")           // Coloca uma barra entre o oitavo e o nono dígitos
      v=v.replace(/(\d{4})(\d)/,"$1-$2")              // Coloca um hífen depois do bloco de quatro dígitos
      return v
    }

    Vue.prototype.protocolLocation = () => {
      return window.location.protocol+'//'+window.location.host
    }

    Vue.prototype.loadingOnOff = loadingOnOff
  }
}
